import { render, staticRenderFns } from "./ExplanationPdfUpload.vue?vue&type=template&id=77fb5442&"
import script from "./ExplanationPdfUpload.vue?vue&type=script&lang=ts&"
export * from "./ExplanationPdfUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports